import React, { useEffect, useState, useMemo,useCallback } from 'react';
import './Sidebar.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { url,subscriptionKey } from "../../constants";
import CmsModal from '../../components/Modals/CmsModal/CmsModal';
import { ListGroup } from "react-bootstrap";
 
import { FaBook, FaClipboardList, FaHome, FaUsers,FaReceipt,FaChevronRight } from 'react-icons/fa';
import { IoWallet,IoSettingsOutline } from 'react-icons/io5';
import { RiBankFill } from 'react-icons/ri';
import { RxLapTimer } from 'react-icons/rx';
 
import ScrollArea from 'react-scrollbar';
import { PermissionActions } from '../../actions';
import { connect } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import { Api } from "../../services/httpService";
 
const SideBar = (props) => {  
    const iconMapping = {
        FaHome: FaHome,
        FaUsers: FaUsers,
        FaClipboardList: FaClipboardList,
        FaBook: FaBook,
        FaUsers: FaUsers,
        IoWallet: IoWallet,
        RiBankFill: RiBankFill,
        FaReceipt: FaReceipt,
        RxLapTimer: RxLapTimer,
        // Add more mappings as needed
    };
 
    let navigate = useNavigate();
    const location = useLocation();
    const [openModal, setOpenModel] = useState(false);
    const [sidebar, setSidebar] = useState(false);
    // let {id} = useParams();
    let id = null;
 
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isHomePage, setIsHomePage] = useState(false);
 
    const [currentUrl, setCurrentUrl] = useState(location?.pathname);
    const showModal = (index) => {
        setCurrentIndex(index)
        setOpenModel(true);
    }
 
    const closeModal = () => {
        setOpenModel(false);
    }
 
    const toggleSidebar = () => {
        if (sidebar) {
            setSidebar(false)
        } else {
            setSidebar(true)
        }
    }
 
    const gotoPage = (url) => {
        navigate(url)
    }
 
    useEffect(() => {
        if (window.localStorage.getItem("_id")) {
            props.getMenuList('Merchant')
            const type = 'menu_access';
            const roleId = window.localStorage.getItem("_roleId");
            if (!roleId) {
                const res = Api('post', '/users/logout');
                if (res) {
                    window.localStorage.clear();
                    window.location.reload();
                }
            }
            props.getUserAccessList(roleId,type)
            props.getPermissionAccess(roleId,type)
        }
        else {
            navigate(`/`);
        }
    }, [])
 
    const checkUrlAccess = async (Url, menuList) => {
        // setTimeout(() => {
            // For other URLs, filter the menu list
            const filteredResult = menuList.filter(item => item.menuUrl.includes(Url));
            if (filteredResult?.length < 1) {
                const baseUrl = currentUrl.split('/').slice(0, 3).join('/') + '/:id';
                let roleMenuData = menuList.find(item => item.menuUrl === baseUrl);
                if (roleMenuData && !checkPermission(roleMenuData.title)) {
                    // Redirect to unauthorized page
                    navigate({
                        pathname: '/user/UnAuthorized',
                        state: {
                            prePath: Url
                        }
                    });
                    return; // Exit the function
                }
            } else {
                // Check permission for the specific URL
                if (!props?.userAccess) {
                    console.error("userAccess is null or undefined");
                }
                else{
                    if(window.localStorage.getItem("_frstlog") === 'true' && props?.userAccess?.length > 0){
                        if(filteredResult.length > 0){
                            for (let i = 0; i < filteredResult.length; i++) {
                                if (checkPermission(filteredResult[i].title)) {
                                    localStorage.setItem('_frstlog',false)
                                    navigate({
                                        pathname: filteredResult[i].menuUrl,
                                        state: {
                                            prePath: Url
                                        }
                                    });
                                    break;
                                }
                            }
                        }
                        else{
                            if (!checkPermission(filteredResult[0].title) || filteredResult[0].menuUrl != Url) {
                                // Redirect to unauthorized page
                                navigate({
                                    pathname: '/user/UnAuthorized',
                                    state: {
                                        prePath: Url
                                    }
                                });
                                // return; // Exit the function
                            }
                        }
                    }
                    else{
                        if (!checkPermission(filteredResult[0].title) || filteredResult[0].menuUrl != Url) {
                            // Redirect to unauthorized page
                            navigate({
                                pathname: '/user/UnAuthorized',
                                state: {
                                    prePath: Url
                                }
                            });
                            // return; // Exit the function
                        }
                    }
                }
            }
        // }, 2000);
    }
 
    const checkPermission = (value) => {
        if (!props?.userAccess) {
            console.error("userAccess is null or undefined");
            return false;
        }
        return props?.userAccess?.some(item => item.allow_action === value);
    }

    const openUserProfile = () => {
        if (checkPermission('User Profile')) {
            navigate(`/userProfile`)
        }
        else {
            // Redirect to unauthorized page
            navigate({
                pathname: '/user/UnAuthorized',
                state: {
                    // prePath: Url
                }
            });
            return; // Exit the function
        }
    }
 
 
    useEffect(() => {
        if (!props.permissionLoading && currentUrl !== '/user/UnAuthorized' && props.menuList?.length > 0) {
            const upCurrentUrl = currentUrl == '/user' ? '/' : currentUrl
            checkUrlAccess(upCurrentUrl, props.menuList);
        }
    }, [currentUrl, props.menuList,props.permissionLoading]);
    
    const menuItems = useMemo(() => {
        if(!props.permissionLoading){
            // if (!props.menuList?.length) return null; // Handle empty menuList
                return props?.menuList?.map((item, index) => {
                    const IconComponent = iconMapping[item.icon];
                    if (item.icon && item.isDisplay && checkPermission(item.title) && (localStorage.getItem("accountStatus") === "Active" || localStorage.getItem("accountStatus") === "OnHold")) {
                        return (
                            <ListGroup.Item
                                key={index}
                                // className={(item.menuUrl === currentUrl) ? "active" : ""}
                                className={(item.menuUrl == currentUrl) ? "active" : (item.menuUrl == '/' && currentUrl == '/user') ? "active" : (currentUrl === '/user/createRequest' && item.menuUrl === '/' && history?.location?.state?.prePath === 'user') ? "active" : (currentUrl === '/user/createRequest' && item.menuUrl === '/user/requests' && history?.location?.state?.prePath != 'user') ? "active" : "active-remove"}
                                onClick={() => gotoPage(item.menuUrl)}
                                as="li"
                            >
                                {IconComponent && <IconComponent className='mx-2' size={20} />}
                                {item.title}
                            </ListGroup.Item>
                        );
                    }
                    else if(localStorage.getItem("accountStatus") != "Active" && localStorage.getItem("accountStatus") != "OnHold" && item.title === "Dashboard"){
                        return (
                            <ListGroup.Item
                                key={index}
                                // className={(item.menuUrl === currentUrl) ? "active" : ""}
                                className={(item.menuUrl == currentUrl) ? "active" : (item.menuUrl == '/' && currentUrl == '/user') ? "active" : (currentUrl === '/user/createRequest' && item.menuUrl === '/' && history?.location?.state?.prePath === 'user') ? "active" : (currentUrl === '/user/createRequest' && item.menuUrl === '/user/requests' && history?.location?.state?.prePath != 'user') ? "active" : "active-remove"}
                                onClick={() => gotoPage(item.menuUrl)}
                                as="li"
                            >
                                {IconComponent && <IconComponent className='mx-2' size={20} />}
                                {item.title}
                            </ListGroup.Item>
                        );
                    }
                    return null; // Ensure to return null for items that don't match the conditions
                }).filter(Boolean); // Filter out null values
        }
    }, [props.menuList, currentUrl, props.permissionLoading]);
 
    return (
        <>
        {
            props.permissionLoading ?
                <></>
            :
            <div className={sidebar ? "row slideBar active_sidebar" : "row slideBar fdfdf"}>
                <div className="boxnew" onClick={toggleSidebar}>
                    <a className="toggleBtn">here</a>
                </div>
                {/* overflow-auto h-100 pb-5 */}
                <div className="col-sm-3">
                    <div className="sidebar">
                        <ScrollArea
                            speed={0.8}
                            className="area h-100"
                            contentClassName="content"
                            vertical={true}
                            smoothScrolling={true}
                            minScrollSize={300}
                            horizontal={false}>
                            <ListGroup className='sidebarMenu' as="ul">
                                {menuItems}
                            </ListGroup>
                        </ScrollArea>
                        <div className="sidebar-bottom-actions px-3 pb-3 mt-auto footer">
                            <div 
                                className={`account-settings-card ${currentUrl === '/userProfile' ? 'active-account-card' : ''}`} 
                                onClick={() => localStorage.getItem("accountStatus") === "Active" || localStorage.getItem("accountStatus") === "OnHold" ? openUserProfile() : null}
                            >
                                <div className="settings-icon-container">
                                    <IoSettingsOutline size={20} className="settings-icon" color="#94a3b8" />
                                </div>
                                <div className="settings-text">
                                    <span className="settings-title">Account</span>
                                    <span className="settings-subtitle">Manage Profile</span>
                                </div>
                                <FaChevronRight size={14} className="settings-chevron" color="#adb5bd" />
                            </div>

                            <p className="footer terms-link mt-3 mb-0 text-start px-2" onClick={() => showModal()}>
                                <button className="mr-3 border-0 bg-transparent text-primary fw-bold p-0 ms-3">
                                    Terms & Conditions
                                </button>
                            </p>
                        </div>
                    </div>
                </div>
                <CmsModal
                    openModal={openModal}
                    closeModal={() => closeModal()}
                    modalTitle="Terms & Conditions"
                />
            </div>
        }
        </>
    )
}
 
const mapStateToProps = ({ PermissionReducers }) => {
    return {
        menuList: PermissionReducers.menuList,
        userAccess: PermissionReducers.userAccess,
        permissionLoading:PermissionReducers.loading
    }
}
 
const mapDispatchToProps = {
    getMenuList: PermissionActions.getMenuList,
    getUserAccessList: PermissionActions.getUserAccessList,
    getPermissionAccess:PermissionActions.getPermissionAccess,
}
 
export default connect(mapStateToProps, mapDispatchToProps)(SideBar)